import { api } from './client'
import type { ApiEnvelope, PaginatedResponse, ActivityLogItem, ActivityFilterParams } from '@/types/api'

interface SpringPage<T> {
    content: T[]
    totalElements: number
    totalPages: number
    number: number
    size: number
}

function adaptPage<T>(raw: SpringPage<T> | PaginatedResponse<T>): PaginatedResponse<T> {
    if ('items' in raw) return raw
    return {
        items: raw.content,
        total: raw.totalElements || 0,
        page: (raw.number || 0) + 1,
        limit: raw.size || 10,
        totalPages: raw.totalPages || 0,
    }
}

export async function fetchActivityLogs(
    page: number = 0,
    pageSize: number = 10,
    params: ActivityFilterParams = {},
    signal?: AbortSignal
): Promise<PaginatedResponse<ActivityLogItem>> {
    try {
        const response = await api.get<ApiEnvelope<SpringPage<ActivityLogItem>>>('/v1/robot/config/action-log', {
            params: {
                page,
                size: pageSize,
                ...params
            },
            signal
        })
        return adaptPage(response.data.responseData)
    } catch (error: any) {
        const message =
            error?.response?.data?.responseMessage ||
            error?.message ||
            'Đã xảy ra lỗi khi lấy lịch sử hoạt động của robot.'
        throw new Error(message)
    }
}